import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FiShield } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { getPrivacy } from '../services/dataService';
import RichTextRenderer from '../components/RichTextRenderer';

const PrivacyPage = () => {
  const [privacy, setPrivacy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPrivacy = async () => {
      try {
        const data = await getPrivacy();
        setPrivacy(data);
      } catch (error) {
        console.error('Failed to load privacy policy:', error);
        setPrivacy({ title: 'Privacy Policy', content: 'Privacy policy content not available at the moment.' });
      } finally {
        setLoading(false);
      }
    };

    loadPrivacy();
  }, []);

  if (loading) {
    return (
      <div className="bg-white min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading privacy policy...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white">
      {/* Header Section */}
      <section className="bg-emerald-900 py-24 text-white relative text-center">
        <div className="max-w-4xl mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
          >
            <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-8 border border-white/20">
              <SafeIcon icon={FiShield} className="w-10 h-10 text-emerald-400" />
            </div>
            <h1 className="text-5xl lg:text-7xl font-black mb-6">Privacy <span className="text-emerald-400">Policy</span></h1>
            <p className="text-xl text-emerald-100/70">Your privacy is important to us. Learn how we protect and handle your personal information.</p>
          </motion.div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 lg:py-24">
        <div className="max-w-4xl mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white rounded-2xl shadow-xl p-8 lg:p-12"
          >
            {privacy && (
              <>
                <RichTextRenderer content={privacy.content} />
                {privacy.last_updated && (
                  <div className="mt-12 pt-8 border-t border-gray-200">
                    <p className="text-sm text-gray-500">
                      Last updated: {new Date(privacy.last_updated).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </p>
                  </div>
                )}
              </>
            )}
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;